<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-review-cart2 inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
         <div class="col-6 col-sm-2 mt-4 ">
           <a *ngIf="!isPaymentSucess">
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div> 
  
        <div class="col-12 col-sm-8 mt-4" *ngIf="!isPaymentSucess">
          <div id="searchResu">Review</div>
          <p id="addthereco">Please review your final purchase. </p>
     
        </div>
  
        <div class="col-12 col-sm-8 mt-4" *ngIf="isPaymentSucess">
                     <div id="searchResu">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.receiptThankYouText}}</div>
                      <p id="addthereco">CONFIRMATION #: {{transactionID}}</p>   
                                       
                     <div class="receiptWhatsNextText" *ngIf="dmvStoreService?.registrationsInCart?.pickupInPerson" [innerHTML]="receiptWhatsNextTextPickup"></div>  

                     <div class="receiptWhatsNextText" *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress" [innerHTML]="receiptWhatsNextTextMail"></div>    
                     
                </div>

         <div class="col-6 col-sm-2 icon-cart mt-5">
         </div>
  
         
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
        <div class="col-12 col-sm-12 m-auto notInPrint" *ngIf="isPaymentSucess">
                    <div class="row">
                        <div class="col-8 mb-5">
                            <div class="prnt-confirm" (click)="print()">
                                <img src="{{globalService.staticResourceURL}}assets/images/Icon-confirm-print.svg" class="img-fluid" >
                                <div id="printYourC">Print Your Confirmation</div>
                            </div>
                        </div>
                        <!--<div class="col-6 mb-5">
                            <div class="confirm-direction">
                                <img src="{{globalService.staticResourceURL}}assets/images/Icon-confirm-directions.svg" class="img-fluid">
                                <div id="printYourC">Get Driving Directions </div>
                            </div>
                        </div>-->
                    </div>
                </div>
       <div class="col-12 col-sm-6 mt-4">
                    <div class="white-box">
                        <div class="cust-detl">
                            <h2 id="customerIn" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Customer Info</h2>
                            <div id="johnDoe123">
                                <span>{{dmvStoreService?.paymentDetails?.fundingToken?.nameOnAccount}}</span>
                                <span>{{dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.line1}}{{dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.line2?(','+ dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.line2):""}}</span>
                                <span>{{dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.city}}, {{(dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.countryCode === 'US')?(dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.stateCode):(dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.nonUsRegion)}} {{dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.postalCode}}</span>
                                <span *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.countryCode !== 'US'">
                                    <span>
                                        {{dmvStoreService?.paymentDetails?.fundingToken?.billingAddress?.countryCode}}
                                    </span>
                                </span>
                                <span>{{dmvStoreService?.paymentDetails?.fundingToken?.billingPhone}}</span>
                                <span>{{dmvStoreService?.paymentDetails?.fundingToken?.billingEmailAddress}}</span>
                            </div>
                        </div>
                        
                        <div class="cust-detl">
                            <h2 id="customerIn" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Payment Method</h2>
                             <div class="d-flex">
                                <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'VI'" src="{{globalService.staticResourceURL}}assets/images/visa@3x.svg" class="img-fluid">
                                 <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'MC'" src="{{globalService.staticResourceURL}}assets/images/mastercard.gif" class="img-fluid">
                                  <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'AE'" src="{{globalService.staticResourceURL}}assets/images/americanexpress.gif" class="img-fluid">
                                   <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'DI'" src="{{globalService.staticResourceURL}}assets/images/discovercard.gif" class="img-fluid">
                                    <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'OT'" src="{{globalService.staticResourceURL}}assets/images/e-chack.gif" class="img-fluid">
                                    <img *ngIf="dmvStoreService?.paymentDetails?.fundingToken?.cardBrand === 'EC'" src="{{globalService.staticResourceURL}}assets/images/e-chack.gif" class="img-fluid">

                                 <div class="payment-creditcard-info">**** **** ****</div>
                                 <div class="payment-creditcard-info">{{dmvStoreService?.paymentDetails?.fundingToken?.accountLast4}}</div>
                            </div>
                            <div class="savedProfileSucess" *ngIf="userStoreService?.saveToProfile && userStoreService?.getUserProfile()?.megUserGUID">
                                Saved to profile successfully
                            </div>
                        </div> 
                        
                        <div class="cust-detl">
                            <h2 *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress" id="customerIn" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Mail Documents To</h2>
                           
                            <div id="johnDoe123" *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress">
                                <section *ngIf="dmvStoreService?.registrationsInCart?.hasAddress">
                                <span>{{dmvStoreService?.registrationsInCart?.mailingAddress?.billigAddress1}} {{dmvStoreService?.registrationsInCart?.mailingAddress?.billigAddress2}}</span>
                                <span>{{dmvStoreService?.registrationsInCart?.mailingAddress?.city}}, {{dmvStoreService?.registrationsInCart?.mailingAddress?.state}} {{dmvStoreService?.registrationsInCart?.mailingAddress?.zip}}
                                    <br/>
                                    {{dmvStoreService?.registrationsInCart?.mailingAddress?.countryCode !== 'US'?countryName:''}}</span>

                                <span  *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress?.permAddressUpdate && dmvStoreService?.registrationsInCart?.dmvRegistrations?.length" >
                                    <div class="review-page-mailing-info">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.permAddressUpdateNote}}</div>
                                </span>
                                <span  *ngIf="dmvStoreService?.registrationsInCart?.mailingAddress?.tempAddressChange && dmvStoreService?.registrationsInCart?.dmvRegistrations?.length" >
                                    <div class="review-page-mailing-info">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.tempAddressChangeNote}}</div>
                                </span>

                                </section>
                                <div   *ngIf="!dmvStoreService?.registrationsInCart?.hasAddress">{{dmvStoreService.registrationsInCart?.mailingText}}
                                </div>
                               
                             
                            </div>
                             <h2  *ngIf="dmvStoreService?.registrationsInCart?.pickupInPerson" id="customerIn" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{globalService.supportKioskPickup?'Pickup from Kiosk':'Pickup Address'}}</h2>
                            <div id="johnDoe123" *ngIf="!globalService.supportKioskPickup && dmvStoreService?.registrationsInCart?.pickupInPerson">
                                <span>{{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.line1}}
                                
                                  {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.line2}}</span>
                                <span>{{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.city}}, {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.stateCode}} {{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.address?.postalCode}}</span>
                                <span>{{dmvStoreService?.registrationsInCart?.pickupInPerson?.pickupLocation?.phone}}</span>
                            </div>

                           <div id="johnDoe123" *ngIf="globalService.supportKioskPickup && dmvStoreService?.registrationsInCart?.pickupInPerson">
                                    {{notifyTo}}
                            </div>
                            </div>

                              <div class="cust-detl" *ngIf="!globalService.supportKioskPickup && dmvStoreService?.registrationsInCart?.pickupInPerson?.authorizedPerson">
                                    <h2 id="customerIn" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Pickup By</h2>
                             <div id="johnDoe123" *ngIf="dmvStoreService?.registrationsInCart?.pickupInPerson?.authorizedPerson">
                                <span>{{dmvStoreService?.registrationsInCart?.pickupInPerson?.authorizedPerson}}
                                
                                 </span>
                               <label class="graytext">(Photo ID required)</label>

                              </div>
                        </div>                        
                    </div>
                </div>

<div class="col-12 col-sm-6 mt-4">
             <div class="p-r">

                <div class="row no-margin pt-3 pb-3 bord-btm"  *ngFor="let dmvRegistration of dmvStoreService?.registrationsInCart?.dmvRegistrations">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{(dmvRegistration?.registration?.availableRenewalOptions && dmvRegistration?.registration?.availableRenewalOptions?.length>0 && dmvRegistration?.selectedRenewalOption)?dmvRegistration?.registration?.availableRenewalOptions[dmvRegistration?.selectedRenewalOption-1].name:''}}
                    {{(dmvRegistration?.registration?.availableRenewalOptions && dmvRegistration?.registration?.availableRenewalOptions?.length>0  && dmvRegistration?.isPlateChange)?" & ":""}}{{(dmvRegistration?.isPlateChange)?"Plate Change":""}}</div>
                    <div class="col-12 col-sm-12">
                        <div class="rectangle-wrapper">
                                <div id="pin">pin:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistration?.registration?.pinNumber}}</div>

                                <div id="pin">plate:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistration?.registration?.licensePlate}}</div>
                        </div>
                        <div class="rectangle-wrapper">
                                <div id="pin">make:</div>
                                <div class="merc-number">{{dmvRegistration?.registration?.makeModel}}</div>   
                        </div>
                        
                        <div class="rectangle-wrapper">
                                <div id="pin">EXPIRATION:</div>
                                <div class="merc-number">{{formatedDate(dmvRegistration?.registration?.expirationDate) | date:'MM/dd/yyyy'}}</div>   
                        </div>
                         <div class="amount-rupees amt-rps-revieew2">{{dmvRegistration?.registration?.totalAmountDue | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                </div>
                  <div class="row no-margin pt-3 pb-3 bord-btm"  *ngFor="let dmvRegistrationManual of dmvStoreService?.registrationsInCart?.dmvRegistrationsManual">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Manual Registration</div>
                    <div class="col-12 col-sm-12">
                        <div class="rectangle-wrapper">
                                <div id="pin">tag Number:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistrationManual?.tagNumber}}</div>

                        </div>
                       
                        
                       
                         <div class="amount-rupees amt-rps-revieew2">{{(dmvRegistrationManual?.amount + dmvRegistrationManual?.lateFee) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                </div>

                <div class="row no-margin pt-3 pb-3 bord-btm"  *ngFor="let dmvRegistrationDuplicate of dmvStoreService?.registrationsInCart?.dmvRegistrationsDuplicate">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Duplicate Registration</div>
                    <div class="col-12 col-sm-12">
                        <div class="rectangle-wrapper">
                                <div id="pin">tag Number:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvRegistrationDuplicate?.tagNumber}}</div>

                        </div>
                       
                        
                       
                         <div class="amount-rupees amt-rps-revieew2">{{(dmvRegistrationDuplicate?.dmvCostData?.totalAmountDue) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                </div>

                <div class="row no-margin pt-3 pb-3 bord-btm" *ngIf="dmvStoreService?.registrationsInCart?.donation">
                    <div class="col-12" id="yearRenewal" [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">Donation</div>
                    <div class="col-12 col-sm-12">
                        <div class="rectangle-wrapper">
                                <div id="pin">charity:</div>
                                <div id="pin-number" class="pin-sm-number">{{dmvStoreService?.registrationsInCart?.donation?.name}}</div>
                        </div>

                         <div class="amount-rupees amt-rps-revieew2">{{dmvStoreService?.registrationsInCart?.donation?.amount | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                </div>
                <div class="row no-margin pt-3 pb-3">
                    <div class="col-12 col-sm-12">
                        <div class="rectangle-wrapper">
                                <div id="pin" class="col-6">Subtotal:</div>
                                <div id="pin-number" class="pin-sm-number col-6	amt-value">{{subTotal | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                        </div>
                        

                         <div class="rectangle-wrapper" *ngIf="IsmailFee">
                                <div id="amountReview" class="col-6">Mail Fee</div>
                                <div id="pin-number" class="pin-sm-number col-6	amt-value">{{mailFee | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>

                        </div>

                        <div class="rectangle-wrapper" >
                                <div id="amountReview" class="col-6">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.providerFeeName}}
                                    <div class="popover__wrapper">
                                        <i class="icon-group-10"  (click)="openServiceFeeModel()"> <svg-image [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-info-payment" [width]="20" [height]="20"></svg-image>
                                         </i>
                                 
                                    </div>
                                </div>
                                <div *ngIf="!(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.consolidatedServiceFee" id="pin-number" class="pin-sm-number col-6	amt-value">{{convenienceFee | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                                <div *ngIf="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.consolidatedServiceFee" id="pin-number" class="pin-sm-number col-6	amt-value">{{(convenienceFee+megAppFee)  | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>

                        </div>
                        
                        
                        <div class="rectangle-wrapper"  *ngIf="!(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.consolidatedServiceFee">
                                <div id="amountReview" class="col-6">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.megAppFee?.name}}</div>
                                <div id="pin-number" class="pin-sm-number col-6	amt-value">{{megAppFee | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                        </div>
                        
                         <div class="amount-rupees amt-rps-revieew2">{{total | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</div>
                    </div>
                </div>
               
                
            </div>            
            
                </div>
                  
                <div class="m-auto pt-5 pb-3"  *ngIf="!isPaymentSucess">
                        <div class="checkbox-container cursorInherit">
                            <form autocomplete="off" class="text-left mb-b" [formGroup]="termsAndConditionsForm">
                            <span >I agree to the </span> <span class="cursorPonter terms textLink"  (click)="openTerms()">Terms &amp; Conditions</span>
                            <label class="d-block cursorPonter">
                                <input type="checkbox" formControlName="termsAndConditions"  [ngClass]="{ 'is-invalid': submitted && !f.termsAndConditions.value }"  name="termsAndConditions">
                                <span class="checkmark" [ngStyle]="f.termsAndConditions.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                         [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>  
                              
                                             
                             </label> 
                                </form>
                            
                        </div>  
                             <div *ngIf="submitted && !f.termsAndConditions.value"  class="invalid-feedback" style="display:block">Please review and accept Terms &amp; Conditions</div>
                            
                    </div>
                  
       
          

        
             
              
         
      </div>
                 <div class="m-auto text-center" >
                  <a *ngIf="!isPaymentSucess">
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>                    
                          
                        <a *ngIf="!isPaymentSucess">
                            <button *ngIf="isTryAgainButtonVisible" (click)="pay()" class="btn btn-primary  btn-continue m-auto">Try Again

                                <i class="fa fa-chevron-right text-right"></i></button>
                            <button *ngIf="!isTryAgainButtonVisible" (click)="pay()" class="btn btn-primary  btn-continue m-auto">Pay {{total | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}

                                <i class="fa fa-chevron-right text-right"></i></button>
                        </a>
                    </div>

     </div>
  </div>
  <dmv-service-fee-model *ngIf="isServiceFeeModelOpen" (closePopup)="closeServiceFeeModel()" >
</dmv-service-fee-model>
 <dmv-terms (closePopup)="closePopupTerms()" *ngIf="isOpenTerms"></dmv-terms>